import { render, staticRenderFns } from "./CardTeacherName.vue?vue&type=template&id=e02a6d44&scoped=true"
import script from "./CardTeacherName.vue?vue&type=script&lang=js"
export * from "./CardTeacherName.vue?vue&type=script&lang=js"
import style0 from "./CardTeacherName.vue?vue&type=style&index=0&id=e02a6d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02a6d44",
  null
  
)

export default component.exports